import React, { memo } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import './css/GameNavBar1.css';

const GameNavBar1 = (props) => {
    const { children, upcomingGame, articlePublished, galleryPublished, showTickets, showProducts } = props;
    const params = useParams();

    const getGameNavlinks = () => {
        const GAME_NAVLINKS = [
            { title: 'Info', link: `/games/${params.gameid}/info`, show: true },
            { title: 'Stats', link: `/games/${params.gameid}/stats`, show: !upcomingGame },
            { title: 'Roster', link: `/games/${params.gameid}/roster`, show: true },
        ];

        if (showProducts) {
            GAME_NAVLINKS.push({ title: 'Store', link: `/games/${params.gameid}/store`, show: true });
        }

        if (articlePublished) {
            GAME_NAVLINKS.push({ title: 'Article', link: `/games/${params.gameid}/article`, show: true });
        }

        if (galleryPublished) {
            GAME_NAVLINKS.push({ title: 'Gallery', link: `/games/${params.gameid}/gallery`, show: true });
        }

        if (showTickets) {
            GAME_NAVLINKS.splice(1, 0, { title: 'Tickets', link: `/games/${params.gameid}/tickets`, show: true });
        }

        GAME_NAVLINKS.push({ title: 'Social Media', link: `/games/${params.gameid}/social-media`, show: true });

        return GAME_NAVLINKS;
    };

    return (
        <>
            <div className="game-navbar1-container full-width">
                {getGameNavlinks().map((item) => {
                    return (
                        <React.Fragment key={item.title}>
                            {item.show ? (
                                <NavLink
                                    activeClassName="game-navbar1-active-nav-item condensed-font-family m-l-40px m-r-40px"
                                    className="game-navbar1-nav-item condensed-font-family m-l-40px m-r-40px"
                                    to={item.link}
                                    exact
                                >
                                    <p className="m-t-0 m-b-0">{item.title}</p>
                                </NavLink>
                            ) : null}
                        </React.Fragment>
                    );
                })}
            </div>
            {children}
        </>
    );
};

GameNavBar1.propTypes = {
    children: PropTypes.node.isRequired,
    upcomingGame: PropTypes.bool.isRequired,
    articlePublished: PropTypes.bool.isRequired,
    galleryPublished: PropTypes.bool.isRequired,
    showTickets: PropTypes.bool.isRequired,
    showProducts: PropTypes.bool.isRequired,
};

export default memo(GameNavBar1);
